export default {
  namespaced: true,
  state: {
    toasts: [],
    position: 'top-50 start-50 translate-middle',
    //message: '',
    //title: '',
    //variant: '',
    counter: 0, // Auto Incrementing Id Field for Vue Reactivity
  },
  getters: {
    getToasts(state) {
      return state.toasts;
    },
  },

  mutations: {
    showToast(state, payload) {
      payload.id = state.counter++;
      state.toasts.push(payload);
    },
    deleteToast(state, index) {
      state.toasts.splice(index, 1);
    },
    deleteAllToasts(state) {
      state.toasts.splice(0);
    },
  },

  actions: {
    showToast(context, payload) {
      context.commit('showToast', payload);
    },
    deleteToast(context, index) {
      context.commit('deleteToast', index);
    },
    deleteAllToasts(context) {
      context.commit('deleteAllToasts');
    },
  },
};
